export class TaxInfoModel {
  public pricesIncludeTax?: boolean;

  constructor(params: TaxInfoModel) {
    this.pricesIncludeTax = params.pricesIncludeTax;
  }

  public static fromCheckoutV1(pricesIncludeTax?: boolean): TaxInfoModel {
    return new TaxInfoModel({
      pricesIncludeTax,
    });
  }
}
